export const SYNC_OPERATION_TYPES = Object.freeze({
  UPSERT: "upsert",
  DELETE: "delete",
});

export const isSyncOperationType = (value) =>
  Object.values(SYNC_OPERATION_TYPES).includes(value);
